/**
 * An object URL of a blob held in the tab's memory, for as long as it is shown: the recorded
 * sample under the review's player. It is revoked when the blob changes or the screen goes.
 */
import { useEffect, useState } from 'react'

export function useObjectUrl(blob: Blob | null): string | null {
  const [url, setUrl] = useState<string | null>(null)
  useEffect(() => {
    if (!blob || typeof URL.createObjectURL !== 'function') return
    const made = URL.createObjectURL(blob)
    setUrl(made)
    return () => {
      setUrl(null)
      URL.revokeObjectURL(made)
    }
  }, [blob])
  return url
}
